import { useState } from "react";
import { fmtBRL, fmtInt } from "@/lib/api";
import { Panel, Empty, GrowthCell, ShareBar, AbcBadge } from "./biShared";

function DimTable({ rows, labelHeader, testid }) {
  if (!rows?.length) return <Empty />;
  return (
    <div className="overflow-x-auto">
      <table className="table table-compact" data-testid={testid}>
        <thead>
          <tr>
            <th>{labelHeader}</th><th className="text-right">Qtd</th><th className="text-right">Copos</th>
            <th className="text-right">Pedidos</th><th className="text-right">Bruto</th>
            <th className="text-right">Ticket</th><th>Share</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.label}>
              <td className="font-bold">{r.label}</td>
              <td className="text-right font-mono">{fmtInt(r.qty)}</td>
              <td className="text-right font-mono">{fmtInt(r.cups)}</td>
              <td className="text-right font-mono">{fmtInt(r.orders)}</td>
              <td className="text-right font-mono font-bold text-green-600">{fmtBRL(r.gross)}</td>
              <td className="text-right font-mono">{fmtBRL(r.ticket)}</td>
              <td><ShareBar pct={r.share} /></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default function BiProductsTab({ data }) {
  const [skuSearch, setSkuSearch] = useState("");
  const skus = (data.by_sku || []).filter((s) =>
    !skuSearch ||
    s.sku.toLowerCase().includes(skuSearch.toLowerCase()) ||
    (s.name || "").toLowerCase().includes(skuSearch.toLowerCase())
  );

  return (
    <div className="space-y-3" data-testid="bi-products-tab">
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-3">
        <Panel title="VENDAS POR TIPO DE COPO" testid="bi-table-types">
          <DimTable rows={data.by_type} labelHeader="Tipo" testid="bi-types-table" />
        </Panel>
        <Panel title="VENDAS POR CAPACIDADE (ML)" testid="bi-table-capacities"
          note="Capacidade extraída do nome do produto — itens sem 'ml' no nome aparecem como '—'.">
          <DimTable rows={data.by_capacity} labelHeader="Capacidade" testid="bi-caps-table" />
        </Panel>
      </div>

      <Panel title={`RANKING DE SKUs (TOP ${data.by_sku?.length || 0})`} testid="bi-table-skus"
        note="Faturamento por SKU = valor BRUTO do item (o líquido só existe no nível do pedido)."
        right={
          <input className="input !py-1 text-xs w-48" placeholder="Buscar SKU ou nome..."
            value={skuSearch} onChange={(e) => setSkuSearch(e.target.value)} data-testid="bi-sku-search" />
        }>
        {skus.length === 0 ? <Empty /> : (
          <div className="overflow-x-auto max-h-[520px] overflow-y-auto">
            <table className="table table-compact">
              <thead>
                <tr>
                  <th>#</th><th>Cl.</th><th>SKU</th><th>Produto</th><th>Tipo</th><th>Cap.</th>
                  <th className="text-right">Qtd</th><th className="text-right">Copos</th>
                  <th className="text-right">Pedidos</th><th className="text-right">Bruto</th>
                  <th>Share</th><th className="text-right">Cresc.</th>
                </tr>
              </thead>
              <tbody>
                {skus.map((s, i) => (
                  <tr key={s.sku} data-testid={`bi-sku-row-${s.sku}`}>
                    <td className="font-mono text-zinc-400">{i + 1}</td>
                    <td><AbcBadge cls={s.abc_class} /></td>
                    <td className="font-mono font-bold">{s.sku}</td>
                    <td className="max-w-[280px] truncate" title={s.name}>{s.name}</td>
                    <td className="text-zinc-500">{s.type || "—"}</td>
                    <td className="font-mono">{s.capacity}</td>
                    <td className="text-right font-mono">{fmtInt(s.qty)}</td>
                    <td className="text-right font-mono">{fmtInt(s.cups)}</td>
                    <td className="text-right font-mono">{fmtInt(s.orders)}</td>
                    <td className="text-right font-mono font-bold text-green-600">{fmtBRL(s.gross)}</td>
                    <td><ShareBar pct={s.share} /></td>
                    <td className="text-right"><GrowthCell pct={s.growth_pct} /></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Panel>
    </div>
  );
}
